import styled from '@emotion/styled';
import { Select } from '@mui/material';

export const SorterSelect = styled(Select)`
  border: 0;
  box-shadow: none;
  line-height: 1.5rem;
  background-color: transparent;

  fieldset {
    border: 0;
  }
`;
